import * as React from "react";
import type { MenuPopoverProps } from "@fluentui/react-components";
import {
  renderMenuPopover_unstable,
  useMenuPopover_unstable,
} from "@fluentui/react-components";
import { useAppMenuPopoverStyles } from "./useAppMenuPopoverStyles";

export const AppMenuPopover = React.forwardRef<
  HTMLDivElement,
  MenuPopoverProps
>((props, ref) => {
  const state = useMenuPopover_unstable(props, ref);
  useAppMenuPopoverStyles(state);
  return renderMenuPopover_unstable(state);
});

AppMenuPopover.displayName = "next/AppMenuPopover";
